import type { RootState, SetState } from '../store';

// TODO: maybe remove this ASAP for performance reasons
export type TimerSliceProps = {
    timer: {
        sessionTime: string;
        setSessionTime: (value: string) => void;
    };
};

export const timerSlice = ({ set }: SetState<RootState>): TimerSliceProps => ({
    timer: {
        sessionTime: '',
        setSessionTime: (value) =>
            set(
                (state) => ({
                    ...state,
                    timer: {
                        ...state.timer,
                        sessionTime: value
                    }
                }),
                undefined,
                'timer/setSessionTime'
            )
    }
});
